// Lightweight client-error telemetry. Fire-and-forget; never throws.
const BUILD = process.env.REACT_APP_BUILD_ID || "dev";

let _sent = 0;
const _seen = new Set();

export function getBuildId() {
  return BUILD;
}

// True for stale/failed dynamic-import (code-split chunk) errors — the classic
// "app was redeployed while your tab was open" failure.
export function isChunkError(err) {
  const s = (err && ((err.name || "") + " " + (err.message || ""))) || String(err || "");
  return /ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed|error loading dynamically imported/i.test(
    s
  );
}

export function reportClientError(payload = {}) {
  try {
    const key = `${payload.kind || ""}|${payload.message || ""}|${payload.section || ""}`;
    if (_seen.has(key) || _sent > 15) return; // de-dupe + per-session cap
    _seen.add(key);
    _sent += 1;

    const u = (typeof window !== "undefined" && window.__kairosUser) || null;
    const body = JSON.stringify({
      build: BUILD,
      route:
        (typeof window !== "undefined" &&
          window.location &&
          (window.location.pathname + window.location.search + window.location.hash)) ||
        "",
      userId: u ? u.id : null,
      role: u ? u.role : null,
      ...payload,
    });

    const url = (process.env.REACT_APP_BACKEND_URL || "") + "/api/client-errors";
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* the reporter must never break the app */
  }
}

// One-time reload guard for stale-chunk recovery. Returns true if it triggered
// a reload (caller should stop). At most once per 60s window → no reload loops,
// but still recovers across future deploys.
export function maybeReloadForChunk() {
  const last = Number(sessionStorage.getItem("kairos-chunk-reload") || 0);
  if (Date.now() - last > 60000) {
    sessionStorage.setItem("kairos-chunk-reload", String(Date.now()));
    window.location.reload();
    return true;
  }
  return false;
}
